/*
payment/bonus/index
*/

import actions from '../common/lib/utils/actions.js';
import bonuses from './lib/bonuses.js';
import fetchBonuses from './lib/fetch-bonuses.js';
/* view contains all dom-elements and updates the rendering */
import view from './lib/view.js';

// TODO: this configuration will later go outside of this module and the 'mobile-core',
// to gain independency and reusability of the module, and this update will be possible
// when the router.js is replaced by react-components.
const conf = {
	/* these are the bonuses used in depositflow*/
	bonusUrl: '/bonus/depositbonuses',
	/* take this as an inparameter?*/
	/* these are the bonuses used in the registrationflow showing both deposit and other bonus*/
	allBonusesUrl: '/bonus/availablebonusesonregistration',
	/* selector to the element that will wrap the dom-elements rendered by the module */
	wrap: null,
	/* when the confirm-button is clicked this will affect the navigation, and this redirection is provided by router.js*/
	confirmCallback: null,
	/* when the bonuslist is empty this will affect the navigation, and this redirection is provided by router.js*/
	isEmptyCallback: null,
	/* bonus Id from shop if the module is initialized from shop */
	selectedShopBonusId: null,
	/* call back for shop deposit bonus */
	shopDepositBonusCallback: null,
	/* payment methods applicable for the bonus*/
	paymentMethods: null
};

function initialization(url, inRegistrationFlow) {
	/* modules in payments are initialized from here.
	After 'init' they are ready to recieve actions.
	They are then connected from the actions following the flux-architecture.*/
	fetchBonuses.init(url, conf.isEmptyCallback);
	bonuses.init({
		isEmptyCallback: conf.isEmptyCallback
	});
	view.init(conf.wrap, conf.confirmCallback, inRegistrationFlow);
	/* this action starts the fetchPaymentmethods and other stores registered for the action */
	actions.setupBonus();
}

function initializationForShopDepositBonus(url) {
	/* We do not initilize the view as the plan is to transition to deposit action page after the bonus selection steps*/
	fetchBonuses.init(url, conf.isEmptyCallback);
	bonuses.init({
		isEmptyCallback: conf.isEmptyCallback,
		shopDepositBonusCallback: conf.shopDepositBonusCallback
	});
	actions.shopHandleBonusForDeposit({
		selectedBonusId: conf.selectedShopBonusId,
		bonusPaymentMethods: conf.paymentMethods
	});
}

export default {
	init(p) {
		/* Initializing bonus module for shop deposit bonus*/
		if (p.selectedShopBonusId) {
			conf.selectedShopBonusId = p.selectedShopBonusId;
			conf.shopDepositBonusCallback = p.shopDepositBonusCallback;
			conf.paymentMethods = p.paymentMethods;
			initializationForShopDepositBonus(conf.bonusUrl);
		} else {
			/* when the bonus are init in the registrationflow */
			const inRegistrationFlow = (p && (p.url === 'register'));
			// const url = (p.url === 'register' ? conf.allBonusesUrl : conf.bonusUrl);
			const url = (inRegistrationFlow ? conf.allBonusesUrl : conf.bonusUrl);
			/* callbacks are parsed from router.js for navigation purposes */
			conf.isEmptyCallback = (p.isEmptyCallback || null);
			conf.confirmCallback = (p.confirmCallback || null);
			conf.wrap = (p.wrapElmSelector || null);
			initialization(url, inRegistrationFlow);
		}
	},
	close() {
		view.close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/index.js